export interface ShapeOption {
	key: string;
	label: string;
	image: string;
	groupKey: string;
}

export interface ShapeGroup {
	key: string;
	label: string;
	image: string;
	options: ShapeOption[];
}

export const kitchenShapes: Record<string, ShapeGroup> = {
	grill: {
		key: 'grill',
		label: 'Grill',
		image: '/app/island-images/1-0.png',
		options: [{ key: 'grill-island', label: 'Grill Island', image: '/app/island-images/1-0.png', groupKey: 'grill' }]
	},
	bar: {
		key: 'bar',
		label: 'Bar',
		image: '/app/island-images/13-0.png',
		options: [{ key: 'bar-island', label: 'Bar Island', image: '/app/island-images/13-0.png', groupKey: 'bar' }]
	},
	corner: {
		key: 'corner',
		label: 'Corner',
		image: '/app/island-images/14-0.png',
		options: [{ key: 'corner-island', label: 'Corner Stand', image: '/app/island-images/14-0.png', groupKey: 'corner' }]
	},
	pizza: {
		key: 'pizza',
		label: 'Pizza',
		image: '/app/island-images/15-0.png',
		options: [{ key: 'pizza-island', label: 'Pizza Stand', image: '/app/island-images/15-0.png', groupKey: 'pizza' }]
	},
	asado: {
		key: 'asado',
		label: 'Asado',
		image: '/app/island-images/16-0.png',
		options: [{ key: 'asado-island', label: 'Asado Stand', image: '/app/island-images/16-0.png', groupKey: 'asado' }]
	},
	'grill-bar': {
		key: 'grill-bar',
		label: 'Grill & Bar',
		image: '/app/island-images/6-0.png',
		options: [
			{ key: 'grill-bar-right', label: 'Grill & Bar ( Bar Right )', image: '/app/island-images/6-0.png', groupKey: 'grill-bar' },
			{ key: 'bar-grill-left', label: 'Bar & Grill ( Bar Left )', image: '/app/island-images/7-0.png', groupKey: 'grill-bar' }
		]
	},
	'l-shaped': {
		key: 'l-shaped',
		label: 'L-Shaped',
		image: '/app/island-images/5-0.png',
		options: [
			{ key: 'l-shaped-bar-right', label: 'L Shaped ( Bar Right )', image: '/app/island-images/5-0.png', groupKey: 'l-shaped' },
			{ key: 'l-shaped-bar-left', label: 'L Shaped ( Bar Left )', image: '/app/island-images/2-0.png', groupKey: 'l-shaped' },
			{ key: 'l-shaped-with-bar-right', label: 'L Shaped with Bar Right', image: '/app/island-images/9-0.png', groupKey: 'l-shaped' },
			{ key: 'l-shaped-with-bar-left', label: 'L Shaped with Bar Left', image: '/app/island-images/8-0.png', groupKey: 'l-shaped' }
		]
	},
	'u-shaped': {
		key: 'u-shaped',
		label: 'U-Shaped',
		image: '/app/island-images/3-0.png',
		options: [
			{ key: 'u-shaped', label: 'U-Shaped', image: '/app/island-images/3-0.png', groupKey: 'u-shaped' },
			{ key: 'u-shaped-corner-right', label: 'U-Shaped with Corner Right', image: '/app/island-images/11-0.png', groupKey: 'u-shaped' },
			{ key: 'u-shaped-corner-left', label: 'U-Shaped with Corner Left', image: '/app/island-images/12-0.png', groupKey: 'u-shaped' },
			{ key: 'u-shaped-middle-corner', label: 'U-Shaped with Middle Corner', image: '/app/island-images/10-0.png', groupKey: 'u-shaped' }
		]
	},
	galley: {
		key: 'galley',
		label: 'Galley',
		image: '/app/island-images/4-0.png',
		options: [{ key: 'galley', label: 'Galley', image: '/app/island-images/4-0.png', groupKey: 'galley' }]
	}
};
